export const dnldSMSTemplates = (builder) => ({
    dnldSMSTemplates: builder.mutation({
        query: ({ search, status, country, startDate, endDate, user_type, userId,loggedin_user_id, user_type_id, associated_enterprise_id }) => {
            return {
                url: '/download_sms_template_list',
                method: 'GET',
                params: { search, status, country, startDate, endDate, user_type, userId, loggedin_user_id, user_type_id, associated_enterprise_id },
                headers: {
                    'Content-Type': 'text/csv',
                  },
                  responseHandler: (response)=>response.blob(),
            };
        },
    }),
});